quoteModule.controller('quoteIntegrationController',
    ['$scope','$location', 'rateQuoteCoordService', 'quoteIntegrationService','erateSessionVarsService', 'identityMgmntService', 'rolePermissionsService',
        'userAuthenticateService','imSessionVarsService','$q', 'routes','rateQuotePersistService', 'DealerInfo','singleInstanceService','commonTLCService',
        'TLCError','AppErrorCodes', 'authRoles', 'providerFeaturesService','AppSettings',
        function ($scope, $location, rateQuoteCoordService, quoteIntegrationService, erateSessionVarsService, identityMgmntService, rolePermissionsService,
                  userAuthenticateService,imSessionVarsService, $q, routes, rateQuotePersistService, DealerInfo, singleInstanceService, commonTLCService,
                  TLCError, AppErrorCodes, authRoles, providerFeaturesService,AppSettings) {

            /*
                 This controller doesn't interact with any real UI page. All we are doing here is capturing
                 data from an external source and setting up the user, dealer, provider, etc. before transfering
                 to the quoting page.
                  */
            $scope.quoteData = null;
            $scope.quoteToken = null;

            $scope.init = function(){
                //we temporarily set the auth token to the "system" token for a couple
                // initial calls until we set the actual user identity
                identityMgmntService.getEngineeringToken()
                    .then(
                        function gotEngineeringToken(engToken){
                            return userAuthenticateService.setUserToken(engToken);
                        },
                        function tokenErr(err){
                            throw new TLCError(new Error(error),AppErrorCodes.Global_Unknown);
                        }
                    )
                    .then(
                        function integrationProcessing(returnNotUsed){
                            var token = $location.search()['tk'];
                            var sourceId = $location.search()['sid'];

                            // Shutdown any prior TLC instance(window) that was open for the source instance (e.g. a Menu window). This will also
                            // "register" the current instance based on sourceId, so that it can be shut down by subsequent instance for the same sourceId.
                            if (sourceId) {
                                singleInstanceService.shutdownPriorInstance(sourceId);
                            }

                            rateQuoteCoordService.startNewQuoteSession(true,true,true);
                            rateQuotePersistService.startNewQuote();
                            //get the integration data by token
                            quoteIntegrationService.getQuoteIntegrationByToken(token)
                                .then(
                                    function gotIntegrationData(data) {
                                        $scope.quoteData = data;
                                        $scope.quoteToken = token;
                                        $scope.quoteData.integrationData = JSON.parse($scope.quoteData.integrationData);

                                        //set up provider, user, vehicle, etc.
                                        imSessionVarsService.setCurrentProviderCode($scope.quoteData.integrationData.providerCode);
                                        identityMgmntService.getProviderByProviderCode($scope.quoteData.integrationData.providerCode.toUpperCase())
                                        .then(
                                            function retrievedProviderByCode(provider) {
                                                imSessionVarsService.setCurrentProviderId(provider.Id);
                                                //KRE - Retrieving ALL the provider settings from DB (this settings will be manage in the future by the Settings View
                                                providerFeaturesService.getProviderApplicationSettings()
                                                    .then(function(elements) {
                                                        // set the cache
                                                        //imSessionVarsService.setCurrentProviderUIRequiredAccess(elements);
                                                        imSessionVarsService.setCurrentProviderSettings(elements);
                                                    });
                                            });

                                        erateSessionVarsService.setQuotingMode($scope.quoteData.integrationData.integrationAppName + '_INTEGRATED_' +
                                            $scope.quoteData.integrationData.mode);

                                        erateSessionVarsService.setIntegrationToken($scope.quoteToken);

                                        quoteIntegrationService.captureIntegrationData($scope.quoteData.integrationData)
                                            .then(
                                                function integrationDataHeld(quoteSession){
                                                    //COM-1008 : when using SSO portal, menu will now have the IM user/dealer id, so
                                                    // quote/contract integration will use that rather than looking up by
                                                    // "menu user account" -- cleaner
                                                    if ($scope.quoteData.integrationData.imUserId){
                                                        var imUserId = $scope.quoteData.integrationData.imUserId;
                                                        var imDealerId = $scope.quoteData.integrationData.imDealerId;

                                                        identityMgmntService.getUserById(imUserId)
                                                        .then(
                                                            function imUserRetrievedById(imUser){
                                                                var locImUser = imUser;
                                                                setupIntegrationUser(imUser, imDealerId)
                                                                .then(
                                                                    function setUserDealership(providerUser){
                                                                        //set up dealership
                                                                        return setupIntegrationDealership(providerUser.dealer, locImUser);
                                                                    }
                                                                )
                                                                .then(
                                                                    function(ok){
                                                                        redirectToQuoting(quoteSession);
                                                                    },
                                                                    function(err){
                                                                        throw new TLCError(new Error(err),AppErrorCodes.IntegrationController_GeneralError);
                                                                    });
                                                            }
                                                        )
                                                    }else{
                                                        // get the IM user from integration username
                                                        identityMgmntService.getUserByMenuUserName($scope.quoteData.integrationData.userName, $scope.quoteData.integrationData.providerCode.toUpperCase())
                                                            .then(
                                                                function imUserRetrieved(imUser){
                                                                    if (!imUser){
                                                                        throw new TLCError(new Error('Could not find user ' + $scope.quoteData.integrationData.userName + ' for provider ' + $scope.quoteData.integrationData.providerCode),AppErrorCodes.IntegrationController_NoUserError);
                                                                    }
                                                                    var locImUser = imUser;
                                                                    //setup user
                                                                    setupIntegrationUser(imUser, null)
                                                                        .then(
                                                                            function setUserDealership(providerUser){
                                                                                //set up dealership
                                                                                return setupIntegrationDealership(providerUser.dealer, locImUser);
                                                                            }
                                                                        )
                                                                        .then(
                                                                            function(ok){
                                                                                redirectToQuoting(quoteSession);
                                                                            },
                                                                            function(err){
                                                                                throw new TLCError(new Error(err),AppErrorCodes.IntegrationController_GeneralError);
                                                                            });
                                                                },
                                                                function(err) {
                                                                    //redirect to Error page
                                                                    $location.url(routes.error);
                                                                });
                                                    }
                                                },
                                                function(err){
                                                    throw new TLCError(new Error(err),AppErrorCodes.IntegrationController_GeneralError);
                                                }
                                            )
                                    },
                                    function(err){
                                        throw new TLCError(new Error(err),AppErrorCodes.IntegrationController_GeneralError);
                                    });
                        })
            }

            //use IM system to capture the user and set up environment variables
            var setupIntegrationUser = function(imUser, imDealerId){
                var defer = $q.defer();

                imSessionVarsService.setCurrentIMUser(imUser);

                var userRoleRouteMap = imSessionVarsService.getRolesAndPrivileges();
                if (userRoleRouteMap == null){
                    rolePermissionsService.generateUserRoleRouteMap();
                }

                //sets the logged in user as the "SSO" user from Menu
                identityMgmntService.getUserSSOToken(imUser.Id)
                    .then(
                        function userSSOTokenRetrieved(usertoken){
                            //set the user's auth token to user session (for future API calls)
                            userAuthenticateService.setUserToken(usertoken);

                            //We know that it is a quote integrated, so the user is and F&I Manager
                            imSessionVarsService.setCurrentIMUserRoles([
                                {
                                    "Type" : "",
                                    "Value" : authRoles.fiManager
                                }]);

                            identityMgmntService.getProviderByProviderCode($scope.quoteData.integrationData.providerCode.toUpperCase())
                                .then(
                                    function retrievedProviderByCode(provider){
                                        imSessionVarsService.setCurrentProviderId(provider.Id);
                                        // get the IM dealership from integration app id
                                        if (imDealerId && imDealerId.length > 0){
                                            identityMgmntService.getDealerById(imDealerId)
                                            .then(
                                                function foundImDealer(imDealer){
                                                    if (imDealer == null) {
                                                        defer.reject("Could not determine dealership for user.");
                                                    }
                                                    defer.resolve({prov: provider, dealer: imDealer})
                                                },
                                                function(err){
                                                    defer.reject(err);
                                                });
                                        }else{
                                            identityMgmntService.getDealerByMenuId($scope.quoteData.integrationData.appDealerID)
                                            .then(
                                                function foundMenuDealer(menuDealer){
                                                    if (menuDealer == null) {
                                                        defer.reject("Could not determine dealership for user.");
                                                    }
                                                    defer.resolve({prov: provider, dealer: menuDealer})
                                                },
                                                function(err){
                                                    defer.reject(err);
                                                });
                                        }
                                    },
                                    function(err) {
                                        defer.reject(err);
                                    });
                        },
                        function(err){
                            defer.reject(err);
                        });

                return defer.promise;
            }

            //use the IM system to find and set up dealership environment variables
            var setupIntegrationDealership = function(menuDealer, imUser) {
                var dealerInfo = new DealerInfo();
                dealerInfo.populateDataFromIdentityManagement(menuDealer);

                try {
                    //if we sso in, we need to set up chat info now that we are in quote creation
                    var provcode = imSessionVarsService.getCurrentProviderCode();

                    // returns a promise
                    return commonTLCService.setupEssentialDealerVars(dealerInfo);
                }
                catch (ex) {
                    switch (ex) {
                        case "ACCOUNT-NOT-FOUND":
                            throw new Error('Could not find dealer account code for integrated dealer: ' + $scope.quoteData.integrationData.appDealerID);
                        case "SPANID-NOT-FOUND":
                            throw new Error('Could not find dealer SPAN id for integrated dealer: ' + $scope.quoteData.integrationData.appDealerID);
                    }
                    throw ex;
                }
            }

            //ultimately we go to the quoting page
            var redirectToQuoting = function(quoteSession){
                if (quoteSession && quoteSession.length > 0){
                    rateQuoteCoordService.setQuoteSessionId(quoteSession);
                    $location.url('/create-quote/?qsession=' + quoteSession)
                }
                else {
                    $location.url('/create-quote');
                }
            }
        }]);
